module.exports = __webpack_public_path__ + "img/21.649a7eef.jpg";